module.exports = __webpack_public_path__ + "static/media/energy-document-icon.88775bc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/energy-document-icon.svg
// module id = 3263
// module chunks = 0